export const GoogleAnalytics =  Object.seal({

  install: (id: string) => {
    if (typeof id !== 'string' || id.trim().length === 0) {
      throw 'Google Analytics ID is undefined'
    }

    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=+new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga', undefined, undefined);

    window[<string>window['GoogleAnalyticsObject']]('create', id, 'auto');
    // ga('send', 'pageview'); // we are sending page view in app.ts whenever the route changes
  },

  isActive: (): boolean => {
    return window[<string>window['GoogleAnalyticsObject']] instanceof Function
  },

  track: (url: string) => {
    if (GoogleAnalytics.isActive()) {
      window[<string>window['GoogleAnalyticsObject']]('send', 'pageview', url)
    }
  }
})



// WEBPACK FOOTER //
// ./lib/analytics/google-analytics.ts